import z from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedDaysAhead.errors.";
const userSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error: translationPath + "user",
  }
);
const scheduleFilterUserCalendarsSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string(),
  },
  {
    invalid_type_error: translationPath + "scheduleFilterUserCalendars",
  }
);
export const scheduleFilterUserSchema = z.object({
  id: z.string().optional(),
  user: userSchema,
  scheduleFilterUserCalendars: z.array(scheduleFilterUserCalendarsSchema),
});

export type TScheduleFilterUserForm = z.infer<typeof scheduleFilterUserSchema>;
